module.exports = __webpack_public_path__ + "img/C918.079c1b89.jpg";